import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class InvoiceReceipt {
  async fetch(page, perPage, all = false, search) {
    const param = search ? `page=${page}&perPage=${perPage}&search=${search}` : all ? "all=true" : `page=${page}&perPage=${perPage}`;
    const response = await ajaxService.get(`/receipt?${param}`);
    if (response.success) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async view(id) {
    const response = await ajaxService.get(`/receipt/${id}`);
    if (response.success) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addreceipt(data) {
    const response = await ajaxService.post(`/receipt/store`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async sendMail(data) {
    const response = await ajaxService.post(`/receipt/send`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async delete(id) {
    const response = await ajaxService.delete(`/receipt/`, id)
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }
}

const invoiceReceiptService = new InvoiceReceipt();
export default invoiceReceiptService;
